import { render, staticRenderFns } from "./StudentDataTable.vue?vue&type=template&id=792f2ddb&scoped=true"
import script from "./StudentDataTable.vue?vue&type=script&lang=js"
export * from "./StudentDataTable.vue?vue&type=script&lang=js"
import style0 from "./StudentDataTable.vue?vue&type=style&index=0&id=792f2ddb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792f2ddb",
  null
  
)

export default component.exports